import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react';
import thunk from 'redux-thunk';

import '@babel/polyfill';
import 'fomantic-ui/dist/semantic.min.css';

import Routes from './routes';
import reducers from './reducers/reducers';

const REDUX_DEV_TOOLS = process.env.REACT_APP_REDUX_DEV_TOOLS;

const composeEnhancersDev = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancersProd = compose;
export const store = createStore(reducers, (!!REDUX_DEV_TOOLS) ?
                composeEnhancersDev(
                    applyMiddleware(thunk)
                ) :
                composeEnhancersProd(
                    applyMiddleware(thunk)
                )
            );
export const persistor = persistStore(store);

const App = (props) => {
    return(
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <Routes />
            </PersistGate>
        </Provider>
    )
}

export default App;